import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import TableSkeleton from "components/skeletons/TableSkeleton";
import TablePagination from "components/tablePagination";
import useApi from "hooks/useApi";
import moment from "moment";
import { useEffect, useState } from "react";

const LeadTable = ({ user_id }) => {
  const [allLead, setAllLead] = useState([]);
  const [reload, setReload] = useState(false);
  const [pagination, setPagination] = useState({
    current_page: 1,
    per_page: 30,
    to: 0,
    from: 0,
    total: 0,
  });

  const { loading, fetchData } = useApi();
  useEffect(() => {
    const getLeads = async () => {
      let finalPagination = { ...pagination };
      const params = `page=${finalPagination?.current_page}&limit=${finalPagination?.per_page}`;
      const endpoint = {
        method: "post",
        url: `/api/admin/lead/list?${params}`,
        data: { user_id: [user_id] },
      };
      const result = await fetchData(endpoint, false);
      if (result.success) {
        const { data: allData, ...rest } = result.data;
        setAllLead(allData || []);
        setPagination(rest);
      }
    };
    getLeads();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reload, pagination?.current_page, pagination?.per_page]);

  const columns = [
    { id: "name", label: "Lead Name" },
    { id: "phone", label: "Phone" },
    { id: "followup_date", label: "Followup Date", style: { width: "150px" } },
    { id: "email", label: "Email" },
    {
      id: "lead_preferred_countries",
      label: "Preferred Countries",
      style: { width: "170px" },
    },
    {
      id: "lead_status",
      label: "Status",
      align: "center",
      style: { width: "140px" },
    },
    { id: "source", label: "Source" },
  ];

  return (
    <Box sx={{ m: "-20px" }}>
      <Paper sx={{ width: "100%", overflow: "hidden", boxShadow: "none" }}>
        {!loading ? (
          <TableContainer
            sx={{ height: "calc(100vh - 188px)", overflowX: "auto" }}
          >
            <Table
              stickyHeader
              sx={{
                "& th:first-of-type": { pl: "20px", pr: "0px" },
                "& th:last-child": { pr: "20px" },
                "& td:first-of-type": { pl: "20px", pr: "0px" },
                "& td:last-child": { pr: "20px" },
              }}
            >
              <TableHead>
                <TableRow>
                  {columns.map((column) => (
                    <TableCell
                      key={column.id}
                      align={column.align}
                      style={{ minWidth: column.minWidth, ...column.style }}
                    >
                      {column.label}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {allLead?.map((row) => (
                  <TableRow hover role="checkbox" key={row.id}>
                    {columns.map((column, i) => {
                      const value = row[column.id];
                      return (
                        <TableCell key={column.id} align={column.align}>
                          {column.format && typeof value === "number" ? (
                            column.format(value)
                          ) : column.id === "live_note" ? (
                            <textarea
                              name=""
                              id=""
                              cols="30"
                              rows="10"
                            ></textarea>
                          ) : column.id === "source" ? (
                            value?.name
                          ) : column.id === "lead_preferred_countries" ? (
                            value.map((cn) => cn.name).join(", ") || "-"
                          ) : column.id === "lead_status" ? (
                            <Box
                              sx={{
                                bgcolor: `${row?.lead_status?.color}15`,
                                color: row?.lead_status?.color,
                                p: "4px",
                                borderRadius: "25px",
                              }}
                            >
                              {row?.lead_status?.name}
                            </Box>
                          ) : column.id === "followup_date" ? (
                            value ? (
                              moment(value).format("ll")
                            ) : (
                              "-"
                            )
                          ) : (
                            value
                          )}
                        </TableCell>
                      );
                    })}
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        ) : (
          <TableSkeleton columns={columns} tableHeight="calc(100vh - 188px)" />
        )}
        <TablePagination
          span={columns?.length}
          setReload={setReload}
          pagination={pagination}
          setPagination={setPagination}
        />
      </Paper>
    </Box>
  );
};

export default LeadTable;
